import React, { FormEvent, useState } from "react";
import { api, IncomeTypeDto } from "shared/api";
import { useApiMethod, UseModalProps } from "shared/lib";
import { Error, Input, LoadingDots, Modal } from "shared/ui";

export interface IIncomeTypeUpdateModal extends UseModalProps {
  companySlug: string;
  data: IncomeTypeDto;
}

export const IncomeTypeUpdateModal = (props: IIncomeTypeUpdateModal) => {
  const incomeTypeList = api.incomeType.useIncomeTypeList(props.companySlug);
  const submit = useApiMethod(api.incomeType.incomeTypeRename);

  const [name, setName] = useState<string>(props.data.name);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();

    if (!name || !name.trim()) return;

    await submit.call(props.companySlug, props.data.id, { name });
    await incomeTypeList.mutate();
    await props.onSuccess();
  };

  return (
    <Modal onClose={props.close} width={400}>
      <form onSubmit={onSubmit}>
        <Modal.Header>
          <Modal.Title>Редактировать тип дохода</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Input autoFocus placeholder="Название" value={name} onChange={(e) => setName(e.target.value)} required />

          {submit.error && <Error style={{ marginTop: 24 }}>{submit.error.message}</Error>}
        </Modal.Body>

        <Modal.Actions>
          <Modal.Action htmlType="button" onClick={props.close}>
            Назад
          </Modal.Action>

          <Modal.Action htmlType="submit" disabled={submit.loading}>
            {!submit.loading ? "Сохранить" : <LoadingDots size={4}>Сохраняем</LoadingDots>}
          </Modal.Action>
        </Modal.Actions>
      </form>
    </Modal>
  );
};

IncomeTypeUpdateModal.defaultProps = {};
